
import img01 from '@/assets/images/ruleList/img_01.png'
import img02 from '@/assets/images/ruleList/img_02.png'
import img03 from '@/assets/images/ruleList/img_03.png'
import img04 from '@/assets/images/ruleList/img_04.png'
import img05 from '@/assets/images/ruleList/img_05.png'
import img06 from '@/assets/images/ruleList/img_06.png'
import img07 from '@/assets/images/ruleList/img_07.png'
import img08 from '@/assets/images/ruleList/img_08.png'
import img09 from '@/assets/images/ruleList/img_09.png'

const ruleNameObj = {
    cyywgz:'常规业务规则',
    szywgz:'税种业务规则',
    gfjjywgz:'规费基金业务规则',
    qyccssgz:'企业全程涉税规则',
    sgywgz:'税干业务规则',
    ssyhywgz:'税收优惠业务规则',
    jckssgz:'进出口税收规则',
    fxkzgz:'风险控制规则',
}
const ruleList = [
    {
        name:'常规业务规则',
        img:img01,
        type:'cyywgz',
        data:[],
        id:6557331,
        rootCategoryId:5925,
        childsFirstId:5926,
    },
    {
        name:'税种业务规则',
        img:img02,
        type:'szywgz',
        data:[],
        id:6558575,
        rootCategoryId:7683,
        childsFirstId:7684,
    },
    {
        name:'规费基金业务规则',
        img:img03,
        type:'gfjjywgz',
        data:[],
        id:6561976,
        rootCategoryId:11878,
        childsFirstId:11879,
    },
    {
        name:'行业涉税规则',
        img:img09,
        type:'hyssgz',
        data:[],
        id:6562083,
        rootCategoryId:12017,
        childsFirstId:12018,
    },
    {
        name:'企业全程涉税规则',
        img:img04,
        type:'qyccssgz',
        data:[],
        id:6563043,
        rootCategoryId:16864,
        childsFirstId:16865,
    },
    // {
    //     name:'税干业务规则',
    //     img:img05,
    //     type:'sgywgz',
    //     data:[],
    //     id:6563911,
    //     rootCategoryId:18767,
    //     childsFirstId:33658,
    // },
    {
        name:'税收优惠业务规则',
        img:img06,
        type:'ssyhywgz',
        data:[],
        id:6564533,
        rootCategoryId:19943,
        childsFirstId:19944,
    },
    {
        name:'进出口税收规则',
        img:img07,
        type:'jckssgz',
        data:[],
        id:6565603,
        rootCategoryId:21043,
        childsFirstId:30629,
    },
    {
        name:'风险控制规则',
        img:img08,
        type:'fxkzgz',
        data:[],
        id:6642485,
        rootCategoryId:19360,
        childsFirstId: 19423,
    },
]

//7个分类const topSevenType = [
const topSevenType1 = [
    {
        name:'政策规定',
        childs:[
            {
                name:'基本政策',
                id:5879,
                code:'gzsc',
            },
            {
                name:'政策解读',
                childs:[
                    {
                        name:'税务总局解读',
                        id:5917,
                        code:'zcjd_swzjjd',
                    },
                    {
                        name:'中央部门解读',
                        id:'5918',
                        code:'zcjd_zybmjd',
                    },
                    {
                        name:'地方税收解读',
                        id:'5919',
                        code:'zcjd_dfssjd',
                    },
                ]
            },
            {
                name:'风险提示',
                code:'fxts',
            },
            {
                name:'合规自查',
                code:'hgzc',
            }
            // {
            //     name:'政策解释',
            // },
        ]
    },
    {
        name:'相关答疑',
    },
    {
        name:'政策变迁',
        code:'fgbq',
    },
    {
        name:'税企争议',
        code:'sqzy'
    },
    {
        name:'稽查焦点',
        code:'jcjd'
    },
    {
        name:'相关案例',
        code:'xggd',
    },
    {
        name:'会计实务',
        code:'kjsw',
    },
]

//const topTenType = [
const topSevenType = [
    {
        name:'政策规定',
        id:5879,
        code:'gzsc',
        childs:[
            {
                name:'基本政策',
                id:5879,
                code:'gzsc',
            },
        ]
    },
    {
        name:'政策解读',
        childs:[
            {
                name:'税务总局解读',
                id:5917,
                code:'zcjd_swzjjd',
            },
            {
                name:'中央部门解读',
                id:'5918',
                code:'zcjd_zybmjd',
            },
            {
                name:'地方税收解读',
                id:'5919',
                code:'zcjd_dfssjd',
            },
        ]
    },
    {
        name:'相关答疑',
    },
    {
        name:'政策变迁',
        code:'fgbq',
    },
    {
        name:'税企争议',
        code:'sqzy',
    },
    {
        name:'稽查焦点',
        code:'jcjd',
    },
    {
        name:'相关案例',
        code:'xggd',
    },
    {
        name:'会计实务',
        code:'kjsw',
    },
    {
        name:'风险提示',
        code:'fxts',
    },
    {
        name:'合规自查',
        code:'hgzc',
    }
]
//政策规定的子级分类

export {
    ruleList,
    ruleNameObj,
    topSevenType,
}